import styled from 'styled-components'

export const EditItemPanel = styled.div<{
  isEditItemPanelActive: boolean
  visibleLfcDimensionsIds: number[]
}>`
  display: ${(props) => (props.isEditItemPanelActive ? 'block' : 'none')};

  .edit-item-header {
    background-color: #ffffff;
    font-weight: 600;
    padding: 20px 15px;
    position: relative;
    pointer-events: all;
    margin-top: calc(80px + 3.58vw); // puller top (80px) + SVG height (20.28/567.06 ≈ 3.58vw)

    @media (min-width: 1200px) {
      margin-top: 0; // no drawer on desktop
      background-color: transparent;
      border-bottom: 1px solid #1d1d1b;
      font-size: 20px;
    }

    .button-done {
      position: absolute;
      top: 50%;
      right: 20px;
      transform: translateY(calc(-50% - 1px));
      border: 1px solid #707070;
      padding: 8px 25px;
      background-color: transparent;
      color: #1b5f4b;
      font-weight: 500;
      font-size: 0.9em;

      @media (min-width: 1200px) {
        right: 60px;

        &:hover {
          background-color: #f2f2e6;
          color: #324c31;
        }
      }
    }
  }

  #product-configurator-controller-root {
    // TODO: get rid of magic constants
    height: calc(100vh - 300px - 3.58vw); // compensates for dynamic puller-based margin-top
    overflow-y: scroll;
    padding: 0 15px;
    background-color: #ffffff;

    @media (min-width: 1200px) {
      max-height: calc(100vh - 240px); // needs improvement
      padding: 30px 15px 75px;
    }

    & *:not(i) {
      font-family: inherit;
      text-transform: inherit;
    }

    .pcc-properties {
      & > *[class$='-container'] {
        &:not(${(props) => props.visibleLfcDimensionsIds.map((id) => `[id$="-${id.toString()}"]`).join()}) {
          display: none;
        }
      }
    }

    .pcc-properties .pcc-thumbnails-container::before {
      display: none;
    }

    .pcc-thumbnails-options-list {
      @media (min-width: 1024px) {
        gap: 10px;
      }
    }
  }
`
